<template>
  <button-line
    :items="items"
    v-bind="$attrs"
  ></button-line>
</template>

<script>
import ButtonLine from '../../components/Parts/ButtonLine';

/**
 * Component DSSButtonLine.vue
 *
 * @module DSSButtonLine
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/views/DSS/DSSButtonLine.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'ExpertToolButtonLine',
  components: {
    ButtonLine,
  },
  computed: {
    items() {
      let items = [
        {
          label: this.$ucfirst(this.$t('myWeekMedication.cardioMedication', { catalog: 'app_mobile' })),
          route: { name: 'DSSCardioMedication' },
        },
        {
          label: this.$ucfirst(this.$t('myWeekMedication.otherMedication', { catalog: 'app_mobile' })),
          route: { name: 'DSSOtherMedication' },
        },
        {
          label: this.$ucfirst(this.$t('medicationRejectionOfGuideline.allergies')),
          route: { name: 'DSSSideEffectsAndAllergies' },
        },
      ];
      if (this.$store.getters["user/hasDSSTitrationAccess"]) {
        items.push({
          label: this.$ucfirst(this.$t('dss.titrationSchemes')),
          route: {name: 'DSSTitrationSchemes'},
        });
      }

      if (this.$store.getters['isTestingEnvironment']){
        items.push({
          label: this.$ucfirst(this.$t('dss.algorithmInputs')),
          route: { name: 'DSSAlgorithmInputs' },
        });
      }

      return items;
    },
  },
};
</script>
